import React from "react";
import "./CheckboxWithAction.css";
import AddButton from "../AddButton/AddButton";

interface CheckboxWithActionProps {
  label: string;
  checked: boolean;
  onToggle: (checked: boolean) => void;
  buttonLabel?: string;
  onButtonClick?: () => void;
  showToggle?: boolean;
}

const CheckboxWithAction: React.FC<CheckboxWithActionProps> = ({
  label,
  checked,
  onToggle,
  buttonLabel,
  onButtonClick,
  showToggle = true
}) => {
  return (
    <div className="checkbox-action-container">
      <label className="checkbox-label">
        {showToggle && (
          <label className="if-switch-toggle">
            <input
              type="checkbox"
              checked={checked}
              onChange={(e) => onToggle?.(e.target.checked)}
            />
            <span className="if-slider-toggle" />
          </label>
        )}
        <span>{label}</span>
      </label>

      {buttonLabel && (
        <span>
            <AddButton onAddClick={() => onButtonClick?.()} addLabel={buttonLabel} />
        </span>
      )}
    </div>
  );
};

export default CheckboxWithAction;